export default "__VITE_ASSET__B6$3GK5p__"